module.exports = __webpack_public_path__ + "static/media/circle-houses.341571eb.png";